const Title: React.FC<{ text: string }> = ({ text }) => {
  return (
    <div className="flex items-center gap-1 text-xl md:font-bold relative text-green">
      {text}
      <div className="hidden md:block border-b border-green w-screen absolute right-[103%] "></div>
    </div>
  )
}

export default Title
